import type { UserMode } from '@respiria/shared';

/**
 * Which modality tours the user has already been shown, in localStorage (issue
 * #57). Drives the auto-launch: the first time you land in a modality — including
 * after upgrading from another one — its tour runs once. Replaying from Settings
 * doesn't touch this. Per-device for now (see the issue for a possible DB flag).
 */
const KEY = 'respiria.tour.seen';

function read(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((m): m is string => typeof m === 'string') : [];
  } catch {
    return [];
  }
}

export function hasSeenTour(mode: UserMode): boolean {
  return read().includes(mode);
}

export function markTourSeen(mode: UserMode): void {
  try {
    const seen = read();
    if (!seen.includes(mode)) localStorage.setItem(KEY, JSON.stringify([...seen, mode]));
  } catch {
    /* storage unavailable (private mode / quota) — the tour just won't persist */
  }
}
